'use strict';

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var internals = {
  operators: ['!', '^', '*', '/', '%', '+', '-', '<', '<=', '>', '>=', '==', '!=', '&&', '||', '??'],
  operatorCharacters: ['!', '^', '*', '/', '%', '+', '-', '<', '=', '>', '&', '|', '?'],
  operatorsOrder: [['^'], ['*', '/', '%'], ['+', '-'], ['<', '<=', '>', '>='], ['==', '!='], ['&&'], ['||', '??']],
  operatorsPrefix: ['!', 'n'],
  literals: {
    '"': '"',
    '`': '`',
    '\'': '\'',
    '[': ']'
  },
  numberRx: /^(?:[0-9]*\.?[0-9]*){1}$/,
  tokenRx: /^[\w\$\#\.\@\:\{\}]+$/,
  symbol: Symbol('formula'),
  settings: Symbol('settings')
};
exports.Parser = /*#__PURE__*/function () {
  function _class(string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, _class);
    if (!options[internals.settings] && options.constants) {
      for (var constant in options.constants) {
        var value = options.constants[constant];
        if (value !== null && !['boolean', 'number', 'string'].includes(typeof value)) {
          throw new Error("Formula constant ".concat(constant, " contains invalid ").concat(typeof value, " value type"));
        }
      }
    }
    this.settings = options[internals.settings] ? options : Object.assign(_defineProperty(_defineProperty(_defineProperty({}, internals.settings, true), "constants", {}), "functions", {}), options);
    this.single = null;
    this._parts = null;
    this._parse(string);
  }
  _createClass(_class, [{
    key: "_parse",
    value: function _parse(string) {
      var _this = this;
      var parts = [];
      var current = '';
      var parenthesis = 0;
      var literal = false;
      var flush = function flush(inner) {
        if (parenthesis) {
          throw new Error('Formula missing closing parenthesis');
        }
        var last = parts.length ? parts[parts.length - 1] : null;
        if (!literal && !current && !inner) {
          return;
        }
        if (last && last.type === 'reference' && inner === ')') {
          // Function

          last.type = 'function';
          last.value = _this._subFormula(current, last.value);
          current = '';
          return;
        }
        if (inner === ')') {
          // Segment
          var sub = new exports.Parser(current, _this.settings);
          parts.push({
            type: 'segment',
            value: sub
          });
        } else if (literal) {
          if (literal === ']') {
            // Reference
            parts.push({
              type: 'reference',
              value: current
            });
            current = '';
            return;
          }
          parts.push({
            type: 'literal',
            value: current
          }); // Literal
        } else if (internals.operatorCharacters.includes(current)) {
          // Operator
          if (last && last.type === 'operator' && internals.operators.includes(last.value + current)) {
            // 2 characters operator

            last.value += current;
          } else {
            parts.push({
              type: 'operator',
              value: current
            });
          }
        } else if (current.match(internals.numberRx)) {
          // Number
          parts.push({
            type: 'constant',
            value: parseFloat(current)
          });
        } else if (_this.settings.constants[current] !== undefined) {
          // Constant
          parts.push({
            type: 'constant',
            value: _this.settings.constants[current]
          });
        } else {
          // Reference
          if (!current.match(internals.tokenRx)) {
            throw new Error("Formula contains invalid token: ".concat(current));
          }
          parts.push({
            type: 'reference',
            value: current
          });
        }
        current = '';
      };
      var _iterator = _createForOfIteratorHelper(string),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var c = _step.value;
          if (literal) {
            if (c === literal) {
              flush();
              literal = false;
            } else {
              current += c;
            }
          } else if (parenthesis) {
            if (c === '(') {
              current += c;
              ++parenthesis;
            } else if (c === ')') {
              --parenthesis;
              if (!parenthesis) {
                flush(c);
              } else {
                current += c;
              }
            } else {
              current += c;
            }
          } else if (c in internals.literals) {
            literal = internals.literals[c];
          } else if (c === '(') {
            flush();
            ++parenthesis;
          } else if (internals.operatorCharacters.includes(c)) {
            flush();
            current = c;
            flush();
          } else if (c !== ' ') {
            current += c;
          } else {
            flush();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      flush();

      // Replace prefix - to internal negative operator

      parts = parts.map(function (part, i) {
        if (part.type !== 'operator' || part.value !== '-' || i && parts[i - 1].type !== 'operator') {
          return part;
        }
        return {
          type: 'operator',
          value: 'n'
        };
      });

      // Validate tokens order

      var operator = false;
      var _iterator2 = _createForOfIteratorHelper(parts),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var part = _step2.value;
          if (part.type === 'operator') {
            if (internals.operatorsPrefix.includes(part.value)) {
              continue;
            }
            if (!operator) {
              throw new Error('Formula contains an operator in invalid position');
            }
            if (!internals.operators.includes(part.value)) {
              throw new Error("Formula contains an unknown operator ".concat(part.value));
            }
          } else if (operator) {
            throw new Error('Formula missing expected operator');
          }
          operator = !operator;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (!operator) {
        throw new Error('Formula contains invalid trailing operator');
      }

      // Identify single part

      if (parts.length === 1 && ['reference', 'literal', 'constant'].includes(parts[0].type)) {
        this.single = {
          type: parts[0].type === 'reference' ? 'reference' : 'value',
          value: parts[0].value
        };
      }

      // Process parts

      this._parts = parts.map(function (part) {
        // Operators

        if (part.type === 'operator') {
          return internals.operatorsPrefix.includes(part.value) ? part : part.value;
        }

        // Literals, constants, segments

        if (part.type !== 'reference') {
          return part.value;
        }

        // References

        if (_this.settings.tokenRx && !_this.settings.tokenRx.test(part.value)) {
          throw new Error("Formula contains invalid reference ".concat(part.value));
        }
        if (_this.settings.reference) {
          return _this.settings.reference(part.value);
        }
        return internals.reference(part.value);
      });
    }
  }, {
    key: "_subFormula",
    value: function _subFormula(string, name) {
      var _this2 = this;
      var method = this.settings.functions[name];
      if (typeof method !== 'function') {
        throw new Error("Formula contains unknown function ".concat(name));
      }
      var args = [];
      if (string) {
        var current = '';
        var parenthesis = 0;
        var literal = false;
        var flush = function flush() {
          if (!current) {
            throw new Error("Formula contains function ".concat(name, " with invalid arguments ").concat(string));
          }
          args.push(current);
          current = '';
        };
        for (var i = 0; i < string.length; ++i) {
          var c = string[i];
          if (literal) {
            current += c;
            if (c === literal) {
              literal = false;
            }
          } else if (c in internals.literals && !parenthesis) {
            current += c;
            literal = internals.literals[c];
          } else if (c === ',' && !parenthesis) {
            flush();
          } else {
            current += c;
            if (c === '(') {
              ++parenthesis;
            } else if (c === ')') {
              --parenthesis;
            }
          }
        }
        flush();
      }
      args = args.map(function (arg) {
        return new exports.Parser(arg, _this2.settings);
      });
      return function (context) {
        var innerValues = [];
        var _iterator3 = _createForOfIteratorHelper(args),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var arg = _step3.value;
            innerValues.push(arg.evaluate(context));
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        return method.call.apply(method, [context].concat(innerValues));
      };
    }
  }, {
    key: "evaluate",
    value: function evaluate(context) {
      var parts = this._parts.slice();

      // Prefix operators

      for (var i = parts.length - 2; i >= 0; --i) {
        var part = parts[i];
        if (part && part.type === 'operator') {
          var current = parts[i + 1];
          parts.splice(i + 1, 1);
          var value = internals.evaluate(current, context);
          parts[i] = internals.single(part.value, value);
        }
      }

      // Left-right operators

      internals.operatorsOrder.forEach(function (set) {
        for (var _i = 1; _i < parts.length - 1;) {
          if (set.includes(parts[_i])) {
            var operator = parts[_i];
            var left = internals.evaluate(parts[_i - 1], context);
            var right = internals.evaluate(parts[_i + 1], context);
            parts.splice(_i, 2);
            var result = internals.calculate(operator, left, right);
            parts[_i - 1] = result === 0 ? 0 : result; // Convert -0
          } else {
            _i += 2;
          }
        }
      });
      return internals.evaluate(parts[0], context);
    }
  }]);
  return _class;
}();
exports.Parser.prototype[internals.symbol] = true;
internals.reference = function (name) {
  return function (context) {
    return context && context[name] !== undefined ? context[name] : null;
  };
};
internals.evaluate = function (part, context) {
  if (part === null) {
    return null;
  }
  if (typeof part === 'function') {
    return part(context);
  }
  if (part[internals.symbol]) {
    return part.evaluate(context);
  }
  return part;
};
internals.single = function (operator, value) {
  if (operator === '!') {
    return value ? false : true;
  }

  // operator === 'n'

  var negative = -value;
  if (negative === 0) {
    // Override -0
    return 0;
  }
  return negative;
};
internals.calculate = function (operator, left, right) {
  if (operator === '??') {
    return internals.exists(left) ? left : right;
  }
  if (typeof left === 'string' || typeof right === 'string') {
    if (operator === '+') {
      left = internals.exists(left) ? left : '';
      right = internals.exists(right) ? right : '';
      return left + right;
    }
  } else {
    switch (operator) {
      case '^':
        return Math.pow(left, right);
      case '*':
        return left * right;
      case '/':
        return left / right;
      case '%':
        return left % right;
      case '+':
        return left + right;
      case '-':
        return left - right;
    }
  }
  switch (operator) {
    case '<':
      return left < right;
    case '<=':
      return left <= right;
    case '>':
      return left > right;
    case '>=':
      return left >= right;
    case '==':
      return left === right;
    case '!=':
      return left !== right;
    case '&&':
      return left && right;
    case '||':
      return left || right;
  }
  return null;
};
internals.exists = function (value) {
  return value !== null && value !== undefined;
};